module.exports = __webpack_public_path__ + "img/face_shape_female_extra_heart.4fe35118.png";